enum ResizeHandleScenario {
    ReadingPane = 1,
    FolderPane,
    MailListColumnHeader1, // Handle between first and second columns
    MailListColumnHeader2, // Handle between second and third columns
    CopilotChatDrawer,
}

export default ResizeHandleScenario;
